(() => {
  if (window.nasalivInitialized) return;
  window.nasalivInitialized = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer = !reducedMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('nl-visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.08 }) : null;
  function initialize(root = document) {
    root.querySelectorAll('[data-nl-compare]').forEach(compare => {
      if (compare.dataset.initialized) return;
      compare.dataset.initialized = 'true';
      const slider = compare.parentElement.querySelector('[data-nl-slider]');
      if (!slider) return;
      const update = () => {
        compare.style.setProperty('--nl-compare-position', `${slider.value}%`);
        compare.querySelector('.nl-compare-label-before').hidden = Number(slider.value) < 15;
        compare.querySelector('.nl-compare-label-after').hidden = Number(slider.value) > 85;
      };
      slider.addEventListener('input', update);
      update();
    });
    root.querySelectorAll('[data-nl-product]').forEach(component => {
      if (component.dataset.initialized) return;
      component.dataset.initialized = 'true';
      const main = component.querySelector('[data-nl-main-image]');
      component.querySelectorAll('[data-nl-thumbnail]').forEach(button => {
        button.addEventListener('click', () => {
          main.src = button.dataset.src;
          main.removeAttribute('srcset');
          main.alt = button.dataset.alt;
          component.querySelectorAll('[data-nl-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      const variantData = component.querySelector('[data-nl-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const form = component.querySelector('form[data-nl-form]');
      if (!form) return;
      const button = form.querySelector('[name="add"]');
      const variantInput = form.querySelector('[name="id"]');
      const selects = component.querySelectorAll('[data-nl-option]');
      selects.forEach(select => select.addEventListener('change', () => {
        const options = Array.from(selects, input => input.value);
        const variant = variants.find(item => item.options.every((option, index) => option === options[index]));
        variantInput.value = variant ? variant.id : '';
        button.disabled = !variant || !variant.available;
        button.textContent = variant && variant.available ? component.dataset.buyLabel : component.dataset.soldLabel;
        if (variant) {
          component.querySelector('[data-nl-price]').textContent = variant.formatted_price;
          const compare = component.querySelector('[data-nl-compare-price]');
          compare.textContent = variant.formatted_compare;
          compare.hidden = !(variant.compare_at_price > variant.price);
          if (variant.image) {
            main.src = variant.image;
            main.removeAttribute('srcset');
          }
          const nextUrl = new URL(location.href);
          nextUrl.searchParams.set('variant', variant.id);
          history.replaceState({}, '', nextUrl);
        }
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled) return;
        const error = component.querySelector('[data-nl-error]');
        error.textContent = '';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const drawer = document.querySelector('cart-drawer');
        try {
          const formData = new FormData(form);
          if (drawer) {
            formData.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
            formData.append('sections_url', location.pathname);
            drawer.setActiveElement(button);
          }
          const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || window.cartStrings.error);
          if (drawer && result.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
          } else {
            location.assign(window.routes.cart_url);
          }
        } catch (issue) {
          error.textContent = issue.message;
        } finally {
          button.disabled = !variantInput.value;
          button.removeAttribute('aria-busy');
        }
      });
    });
    root.querySelectorAll('.nl-reveal').forEach(element => {
      if (observer) observer.observe(element);
      else element.classList.add('nl-visible');
    });
  }
  const start = () => {
    initialize();
    if (observer) document.documentElement.classList.add('nl-reveal-ready');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
